"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var classnames_1 = require("../util/classnames");
var react_prop_types_1 = require("../react-prop-types");
var calculate_position_1 = require("./utils/calculate-position");
var get_container_1 = require("./utils/get-container");
var owner_document_1 = require("./utils/owner-document");
var _1 = require("../util/_");
/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = /** @class */ (function (_super) {
    __extends(Position, _super);
    function Position(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.getTarget = function () {
            var target = _this.props.target;
            var targetElement = typeof target === 'function' ? target() : target;
            return targetElement && ReactDOM.findDOMNode(targetElement) || null;
        };
        _this.maybeUpdatePosition = function (placementChanged) {
            var target = _this.getTarget();
            if (!_this.props.shouldUpdatePosition &&
                target === _this._lastTarget &&
                !placementChanged) {
                return;
            }
            _this.updatePosition(target);
        };
        _this.updatePosition = function (target) {
            _this._lastTarget = target;
            if (!target) {
                _this.setState({
                    positionLeft: 0,
                    positionTop: 0,
                    arrowOffsetLeft: undefined,
                    arrowOffsetTop: undefined
                });
                return;
            }
            var overlay = ReactDOM.findDOMNode(_this);
            var container = get_container_1.getContainer(_this.props.container, owner_document_1.ownerDocument(_this).body);
            _this.setState(calculate_position_1.calculatePosition(_this.props.placement, overlay, target, container, _this.props.containerPadding));
        };
        _this.state = {
            positionLeft: 0,
            positionTop: 0,
            arrowOffsetLeft: undefined,
            arrowOffsetTop: undefined
        };
        _this._needsFlush = false;
        _this._lastTarget = null;
        return _this;
    }
    Position.prototype.componentDidMount = function () {
        this.updatePosition(this.getTarget());
    };
    Position.prototype.componentWillReceiveProps = function () {
        this._needsFlush = true;
    };
    Position.prototype.componentDidUpdate = function (prevProps) {
        if (this._needsFlush) {
            this._needsFlush = false;
            this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
        }
    };
    Position.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className;
        var _b = this.state, positionLeft = _b.positionLeft, positionTop = _b.positionTop, arrowOffsetLeft = _b.arrowOffsetLeft, arrowOffsetTop = _b.arrowOffsetTop;
        var childProps = _1.omit(this.props, ['children', 'className', 'target', 'container', 'containerPadding', 'shouldUpdatePosition']);
        var child = React.Children.only(children);
        return React.cloneElement(child, Object.assign({}, childProps, {
            arrowOffsetLeft: arrowOffsetLeft,
            arrowOffsetTop: arrowOffsetTop,
            // FIXME: Don't forward `positionLeft` and `positionTop` via both props
            // and `props.style`.
            positionLeft: positionLeft,
            positionTop: positionTop,
            className: classnames_1.classNames(className, child.props.className),
            style: Object.assign({}, child.props.style, {
                left: positionLeft,
                top: positionTop
            })
        }));
    };
    Position.propTypes = {
        /**
         * A node, element, or function that returns either. The child will be
         * be positioned next to the `target` specified.
         */
        target: PropTypes.oneOfType([
            react_prop_types_1.componentOrElement, PropTypes.func
        ]),
        /**
         * "offsetParent" of the component
         */
        container: PropTypes.oneOfType([
            react_prop_types_1.componentOrElement, PropTypes.func
        ]),
        /**
         * Minimum spacing in pixels between container border and component border
         */
        containerPadding: PropTypes.number,
        /**
         * How to position the component relative to the target
         */
        placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
        /**
         * Whether the position should be changed on each update
         */
        shouldUpdatePosition: PropTypes.bool,
        className: PropTypes.string,
        children: PropTypes.node
    };
    Position.defaultProps = {
        containerPadding: 0,
        placement: 'right',
        shouldUpdatePosition: false
    };
    return Position;
}(React.Component));
exports.Position = Position;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/react-overlays/position.js
// module id = 480
// module chunks = 0 1 2 3 4 5 6